<template>
  <Teleport to="body">
    <transition name="modal">
      <div v-if="visible" class="twofa-dialog-overlay" @click="closeDialog">
      <div class="twofa-dialog" @click.stop>
        <h3>二步验证设置</h3>
        <div class="twofa-hint">此信息仅展示一次，请务必保存</div>
        <div class="twofa-secret-box">密钥：{{ secret }}</div>
        <div class="twofa-otpauth">otpauth：{{ otpauth }}</div>
        <div class="qr-box">
          <canvas ref="twofaQrCanvas" width="220" height="220"></canvas>
        </div>
        <div class="form-group" style="margin-top:10px;">
          <label>请输入两步验证码进行确认</label>
          <input type="text" v-model="testCode" placeholder="6位验证码" maxlength="6" />
        </div>
        <div class="twofa-actions">
          <button class="copy-btn" @click="copySecret"><i class="fa-solid fa-copy"></i></button>
          <button class="primary-btn" @click="confirmSetup">验证并保存</button>
          <button class="secondary-btn" @click="closeDialog">取消</button>
        </div>
      </div>
    </div>
  </transition>
  </Teleport>
</template>

<script>
import { ref, watch, nextTick } from 'vue'
import QRCode from 'qrcode'
import { message } from '@/utils/ui-service'

export default {
  name: 'TwofaDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    secret: {
      type: String,
      default: ''
    },
    otpauth: {
      type: String,
      default: ''
    }
  },
  emits: ['update:visible', 'confirm'],
  setup(props, { emit }) {
    const twofaQrCanvas = ref(null)
    const testCode = ref('')

    const drawQrCode = () => {
      const c = twofaQrCanvas.value
      if (!c || !props.otpauth) return
      QRCode.toCanvas(c, props.otpauth, { errorCorrectionLevel: 'M', margin: 1 })
        .catch(() => {
          const ctx = c.getContext('2d')
          ctx.fillStyle = '#eef7ff'
          ctx.fillRect(0, 0, c.width, c.height)
          ctx.fillStyle = '#245a8d'
          ctx.fillRect(20, 20, c.width - 40, c.height - 40)
          ctx.fillStyle = '#fff'
          ctx.fillRect(35, 35, c.width - 70, c.height - 70)
        })
    }

    watch(() => props.visible, (newVal) => {
      if (newVal) {
        testCode.value = ''
        nextTick(() => {
          drawQrCode()
        })
      }
    })

    const copySecret = () => {
      const t = `Secret: ${props.secret}\nURI: ${props.otpauth}`
      try {
        navigator.clipboard && navigator.clipboard.writeText(t)
        message.success('配置信息已复制')
      } catch(e) {
        console.log(e)
        message.error('复制失败')
      }
    }

    const closeDialog = () => {
      emit('update:visible', false)
    }

    const confirmSetup = () => {
      if (!testCode.value || testCode.value.length < 6) {
        message.error('请输入6位两步验证码')
        return
      }
      emit('confirm', testCode.value)
    }

    return {
      twofaQrCanvas,
      testCode,
      copySecret,
      closeDialog,
      confirmSetup
    }
  }
}
</script>

<style scoped>
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.3s ease;
}
.modal-enter-from, .modal-leave-to {
  opacity: 0;
}
.modal-enter-from .twofa-dialog,
.modal-leave-to .twofa-dialog {
  transform: scale(0.9);
}
.modal-enter-to .twofa-dialog,
.modal-leave-from .twofa-dialog {
  transform: scale(1);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.twofa-dialog-overlay { 
  position: fixed; 
  top: 0; 
  left: 0; 
  width: 100vw; 
  height: 100vh; 
  background: rgba(0,0,0,0.5); 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  z-index: var(--z-modal-top); 
}

.twofa-dialog { 
  background: #fff; 
  padding: 20px; 
  border-radius: 12px; 
  box-shadow: 0 15px 35px rgba(0,0,0,0.1); 
  width: 100%; 
  max-width: 480px; 
}

.twofa-dialog h3 { 
  margin: 0 0 10px 0; 
  color: #245a8d; 
}

.twofa-hint { 
  color: #d4380d; 
  font-size: 12px; 
  margin-bottom: 10px; 
}

.twofa-secret-box { 
  background: #f7fbff; 
  border: 1px solid #e0f0ff; 
  border-radius: 8px; 
  padding: 12px; 
  word-break: break-all; 
}

.twofa-otpauth { 
  margin-top: 8px; 
  font-size: 12px; 
  color: #245a8d; 
  word-break: break-all; 
}

.twofa-actions { 
  display: flex; 
  gap: 10px; 
  align-items: center; 
  margin-top: 12px; 
}

.qr-box { 
  margin-top: 12px; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
}

.form-group label {
  color: #3878b8;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #cfe6ff;
  border-radius: 8px;
  background: #fff;
  box-sizing: border-box;
  margin-top: 6px;
}

.form-group input:focus {
  outline: none;
  border-color: #0071e3;
  box-shadow: 0 0 0 2px rgba(0, 113, 227, 0.1);
}

.copy-btn { 
  background: #eef7ff; 
  color: #245a8d; 
  border: 1px solid #cfe6ff; 
  padding: 8px 12px; 
  border-radius: 8px; 
  cursor: pointer; 
}

.primary-btn { 
  background: #3da5ff; 
  color: #fff; 
  border: none; 
  padding: 10px 14px; 
  border-radius: 8px; 
  cursor: pointer; 
  flex: 1; 
}

.secondary-btn { 
  background: #eef7ff; 
  color: #245a8d; 
  border: 1px solid #cfe6ff; 
  padding: 10px 14px; 
  border-radius: 8px; 
  cursor: pointer; 
  flex: 1; 
}

.dark-theme .twofa-dialog { 
  background: #2f2f31; 
  color: #e4e7ed; 
}

.dark-theme .twofa-dialog h3 { 
  color: #e4e7ed; 
}

.dark-theme .twofa-secret-box { 
  background: #3a3a3c; 
  border-color: #4c4d4f; 
  color: #e4e7ed; 
}

.dark-theme .twofa-otpauth { 
  color: #e4e7ed; 
}

.dark-theme .copy-btn { 
  background: #3a3a3c; 
  color: #e4e7ed; 
  border-color: #4c4d4f; 
}

.dark-theme .primary-btn { 
  background: #67c23a; 
  color: #fff; 
}

.dark-theme .secondary-btn { 
  background: #3a3a3c; 
  color: #e4e7ed; 
  border-color: #4c4d4f; 
}

.dark-theme .form-group input {
  background: #3a3a3c;
  border-color: #4c4d4f;
  color: #e4e7ed;
}

.dark-theme .form-group label {
  color: #e4e7ed;
}
</style>
